<section>
    <span c-activity-log-blurb activity="activity"></span>{{"setResponsibleRegisterNodeLog.message"|translate}}
    <span class="tag">{{Responsible}}</span>
    <div c-activity-log-message activity="activity"></div>
</section>